import axios from 'axios';

export default {

  getElements (projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements`);
  },

  findElements (projectId, prolog) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements?prolog=${encodeURIComponent(prolog)}`);
  },

  createElement (projectId, element) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements`, element);
  },

  updateElement (projectId, element) {
    return axios.put(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements/${element.id}`, element);
  },

  deleteElement (projectId, elementId) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements/${elementId}`);
  },

  missingParenthesis(prolog) {
    if(!prolog) {
      return false
    }
    let regex = /[^,()]+\([^()]*$/;
    return prolog.match(regex);
  },

  checkAdditionnalElements(element) {
    if(!element) {
      // skip if no element
      return []
    }
    if(this.missingParenthesis(element)) {
      // skip if predicate is not complete
      return []
    }
    // identify predicates comma separated
    let regex = /[^,()]+\([^()]*\)|[^,]+/g;
    let matches = element.match(regex).filter(match => match.trim() !== '')
    if (!matches) {
      // skip if only one predicate
      return []
    }
    matches = matches.map(match => match.trim());
    if(matches.length < 2) {
      // skip if comma found but only one predicate
      return []
    }
    return matches
  },

  findElementsByProlog(projectId, prologs) {
    return prologs.map(prolog => this.findElements(projectId, prolog))
  },

  filterElements(elements, elementsToExclude) {
    const excludedElementIds = elementsToExclude.map(elt => elt.id)
    return elements.filter(elt => !excludedElementIds.includes(elt.id));
  },
};